import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import {
  DEFAULT_LOCALE,
  FALLBACK_LOCALE,
  SUPPORTED_LANGUAGE_CODES,
  isRtl,
} from "./locales";

// Çeviriler pakete gömülmez; çalışma anında public/locales/<lng>/<ns>.json
// üzerinden tembel (lazy) yüklenir. Böylece 15 dil ilk yüklemeyi şişirmez ve
// yeni çeviri eklemek için yeniden derleme gerekmez.
export const NAMESPACES = ["common", "auth", "dashboard", "public"] as const;

void i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: FALLBACK_LOCALE,
    supportedLngs: SUPPORTED_LANGUAGE_CODES,
    // tr-TR gibi bölgesel kodları temel dile indir (sadece <lng>/ yüklenir).
    load: "languageOnly",
    nonExplicitSupportedLngs: true,
    ns: NAMESPACES as unknown as string[],
    defaultNS: "common",
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    detection: {
      // Önce kullanıcının kayıtlı tercihi, sonra tarayıcı dili.
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "aice.locale",
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false, // React zaten XSS'e karşı kaçışlar.
    },
    react: {
      useSuspense: true,
    },
  });

// <html lang/dir> değerlerini aktif dile göre senkron tut (RTL desteği).
function applyDocumentDirection(lng: string) {
  const root = document.documentElement;
  root.setAttribute("lang", lng);
  root.setAttribute("dir", isRtl(lng) ? "rtl" : "ltr");
}

applyDocumentDirection(i18n.resolvedLanguage || DEFAULT_LOCALE);
i18n.on("languageChanged", applyDocumentDirection);

export default i18n;
